export enum SortEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}
